import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledItemsCountBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledItemsCount = styled(FlexRow)`
    display: flex;
    justify-content: center;
    align-items: center;
    ${mixins.setFontVariant("dataTable1", colorsPalettes.carbon["0"])};

    height: 20px;
    min-width: 20px;
    background-color: ${colorsPalettes.blue["400"]};
    border-radius: 16px;
    user-select: none;

    &:hover {
        background-color: ${colorsPalettes.blue["500"]};
    }
`;
